<template>
  <el-dialog
    title="Relatórios de Pretendentes"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="35%"
  >
    <el-form
      :model="relatorio"
      ref="form"
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
      :rules="validacao"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Relatório" style="font-weight: bold;">
            <el-select
              auto-complete="off"
              v-model="relatorio.nome"
              @change="limparFiltros"
              clearable
              placeholder
              style="width: 100%;"
            >
              <el-option
                v-for="item in tiposRelatorios"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="exibirCampoPeriodo" :gutter="24">
        <el-col :span="8">
          <el-form-item label="Status" style="font-weight: bold;">
            <el-select
              auto-complete="off"
              clearable
              v-model="relatorio.pretendente.status"
              style="width: 100%;"
            >
              <el-option label="Todos" value="TODOS"></el-option>
              <el-option
                v-for="item in statusPretendentes"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Data Inicial" prop="dataInicial" style="font-weight: bold;">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Data Final" prop="dataFinal" style="font-weight: bold;">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="exibirCampoCliente">
        <el-col :span="24">
          <el-form-item label="Pretendente" style="font-weight: bold;">
            <el-select
              v-model="relatorio.pretendente"
              :remote-method="filtrarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder
              loading-text="Carregando clientes"
              no-data-text="Nenhum cliente encontrado"
              filterable
              clearable
              @clear="limparCampoPretendente"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in clientesDisponiveis"
                :key="item.id"
                :label="formatarSelectCliente(item)"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="exibirCampoAtendente" :gutter="24">
        <el-col :span="24">
          <el-form-item label="Atendente" style="font-weight: bold;"> 
            <el-select
              v-model="relatorio.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              placeholder
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              clearable
              @clear="relatorio.usuario = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirEstadoCidadeBairro">
        <el-col :span="2" :md="5">
          <el-form-item label="Estado" prop="estado" style="font-weight: bold;">
            <el-select v-model="relatorio.estado"
                value-key="id"
                placeholder=""
                filterable
                clearable
                default-first-option
                style="width: 100%">
              <el-option v-for="item in estados" :key="item.id" :label="item.sigla" :value="item"/>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="7" :md="9">
          <el-form-item label="Cidade" prop="cidade" style="font-weight: bold;">
            <el-select
              v-model="relatorio.cidade"
              :remote-method="recuperarCidadesSelect"
              :loading="loadingCidades"
              value-key="id"
              placeholder=""
              loading-text="Carregando cidades"
              no-data-text="Nenhuma cidade encontrada"
              filterable
              clearable
              remote
              default-first-option
              style="width: 100%">
                <el-option
                  v-for="item in cidadesDisponiveis"
                  :key="item.id"
                  :label="item.nome"
                  :value="item">
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="7" :md="10">
          <el-form-item label="Bairro" prop="bairro" style="font-weight: bold;">
            <el-select
              v-model="relatorio.pretendente.bairro"
              :remote-method="recuperarBairrosSelect"
              :loading="loadingBairros"
              value-key="id"
              placeholder=""
              loading-text="Carregando bairros"
              no-data-text="Nenhum bairro encontrado"
              filterable
              clearable
              @clear="relatorio.pretendente = undefined"
              remote
              default-first-option
              style="width: 100%">
                <el-option v-for="item in bairrosDisponiveis" :key="item.id" :label="item.nome" :value="item"/>
              </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="primary" size="small" @click="gerar()" round class="btn-box-shadow">Gerar Relatório</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

import funcoes from "../../../util/funcoes.js";
import { ESTADOS, STATUS_LISTA_ESPERA_PRETENDENTES } from "../../../util/constantes.js";

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      tiposRelatorios: [
        {
          value: "PRETENDENTES_CADASTRADOS",
          label: "Pretendentes Cadastrados"
        },
        {
          value: "CONTATO_REALIZADO",
          label: "Contatos Realizados"
        }
      ],
      relatorio: {
        nome: "",
        usuario: {},
        cliente: {},
        pretendente: {
          id: 0,
          operacao: "ALUGUEL",
          status: 'TODOS',
          bairro: {}
        },
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes()
      },

      validacao: {
        dataInicial: [{ required: true }],
        dataFinal: [{ required: true }]
      },

      loadingUsuarios: false,
      loadingClientes: false,
      loadingCidades: false,
      loadingBairros: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      auxUsuario: {},
      usuariosSelecionados: [],
      cidadesDisponiveis: [],
      bairrosDisponiveis: []
    };
  },
  computed: {
    ...mapState("alugueisRelatoriosStore", {
      usuariosDisponiveis(state) {
        return state.usuariosDisponiveis;
      },
      clientesDisponiveis(state) {
        return state.clientesDisponiveis;
      }

    }),
    exibirCampoCliente() {
      return this.relatorio.nome == "CONTATO_REALIZADO";
    },
    exibirCampoAtendente() {
      return (
        this.relatorio.nome == "CONTATO_REALIZADO" || this.relatorio.nome == "PRETENDENTES_CADASTRADOS"
      );
    },
    exibirEstadoCidadeBairro(){
      return (
        this.relatorio.nome === 'PRETENDENTES_CADASTRADOS'
        )
    },
    exibirCampoPeriodo() {
      return this.relatorio.nome;
    },
    estados() { return ESTADOS },
    statusPretendentes() { return STATUS_LISTA_ESPERA_PRETENDENTES }
    
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisRelatoriosStore", [
      "gerarRelatorio",
      "listarUsuarios",
      "listarClientes"
    ]),
    gerar() {
      this.$refs["form"].validate(elFormValidation => {
        const formIsInvalid = !elFormValidation;
        if(formIsInvalid){
          this.$message.warning("Insira os campos obrigatórios.");
          return;
        }
      this.relatorio.pretendente = {
        status: this.relatorio.pretendente.status,
        operacao: this.relatorio.pretendente.operacao,
        bairro: this.relatorio.pretendente.bairro,
        id: this.relatorio.pretendente.id
      }   
      if(this.relatorio.pretendente && this.relatorio.pretendente.id !== 0) {
        this.relatorio.cliente.id = this.relatorio.pretendente.id
      }

      if (this.relatorio.pretendente.status === 'TODOS') { delete this.relatorio.pretendente.status }

      this.showLoading();
      this.gerarRelatorio(this.relatorio)
        .then(resultado => {
          this.hideLoading();
          if (resultado.status == "SUCESSO") {
            window.open(resultado.mensagem, "_blank");
          }
          this.limparFiltros()
        })
        .catch(() => {
          this.hideLoading();
          this.limparFiltros();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
      })  
    },

    // SELECTS
    filtrarClientesSelect(queryString) {
      let payload = { categoriaPesquisa: 'PRETENDENTE' };

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingClientes = true;
      this.listarClientes(payload)
        .then(() => {
          this.loadingClientes = false;
        })
        .catch(() => {
          this.loadingUsuarios = false;
        });
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      });
    },
    recuperarCidadesSelect(queryString) {
      if(this.relatorio.estado.id === 0) {
        this.$message.warning("Selecione o estado");
        return;
      }
      let payload = { nome: queryString, estado: { id: this.relatorio.estado.id } };
      
      this.loadingCidades = true;
      this.listarCidades(payload)
      .then((resultado) => {
        this.loadingCidades = false;
        this.cidadesDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
      }).catch(() => {
        this.loadingCidades = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    recuperarBairrosSelect(queryString) {
      if(this.relatorio.cidade.id === 0) {
        this.$message.warning("Selecione a cidade");
        return;
      }
      let payload = { nome: queryString, cidade: { id: this.relatorio.cidade.id } };

      this.loadingBairros = true;
      this.listarBairros(payload)
      .then((resultado) => {
        this.loadingBairros = false;
        this.bairrosDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
      }).catch(() => {
        this.loadingBairros = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    // UTIL
    formatarSelectCliente(cliente){
      return funcoes.formatarSelectCliente(cliente);
    },
    limparFiltros() {
      this.relatorio = {
        nome: this.relatorio.nome,
        usuario: {},
        cliente: {},
        pretendente: {
          id: 0,
          operacao: "ALUGUEL",
          status: 'TODOS',
          bairro: {}
        },
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes()
      }
    },
    adicionarUsuarioSelecionado() {
      this.usuariosSelecionados.push(this.auxUsuario);
    },
    removerUsuarioSelecionado(usuario) {
      var i;
      for (i = 0; i < this.usuariosSelecionados.length; i++) {
        if (this.usuariosSelecionados[i].id == usuario.id) {
          this.usuariosSelecionados.splice(i, 1);
        }
      }
    },
    limparCampoPretendente() {
      this.relatorio.pretendente = {
        id: 0,
        operacao: "ALUGUEL",
        status: 'TODOS',
        bairro: {}
      }
    },
    fechar() {
      this.relatorio.nome = "";
      this.$emit("close");
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    }
  }
};
</script>

<style scoped>
.form-item {
  width: 100%;
}
.select {
  font-size: 50%;
}
</style>